<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{ isEdit ? $t('com.file.add-announcement.edit-announcement') : $t('com.file.announcements.add-announcement')}}</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$emit('closeAnnoucement');}">
                    <img src="../../../../../assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <section>
                    <label :class="[isGroups ? 'esesja-modal__wraper__body__label tabs selected' : 'esesja-modal__wraper__body__label tabs']" @click="changeGroup(true)">{{$t('com.file.import-concatc-summary.groups')}}</label>
                    <label :class="[!isGroups ? 'esesja-modal__wraper__body__label tabs selected' : 'esesja-modal__wraper__body__label tabs']" @click="changeGroup(false)">{{$t('com.file.add-multiple-users-modal.modal-title')}}</label>
                    <section v-if="isGroups" class="selectedSection">
                        <Multiselect v-model="value"
                                     mode="tags"
                                     ref="searchGroups"
                                     :placeholder="$t('com.file.add-announcement.search-group-placeholder')"
                                     :close-on-select="false"
                                     :searchable="true"
                                     class="multiselect-green"
                                     :noResultsText="$t('com.global.no-results')"
                                     :noOptionsText="$t('com.global.no-options')"
                                     :options="options" 
                                     @click="setInputFocusGroups">
                                     <template #tag="{ option, handleTagRemove, disabled  }">
                                        <MultiselectPersonTag :option="option" :disabled="disabled" @click="handleTagRemove(option, $event)" :force-hide-avatar=true />
                                    </template>
                        </Multiselect>

                    </section>
                    <section v-if="!isGroups" class="selectedSection">
                        <Multiselect v-model="value2"
                                     mode="tags"
                                     ref="searchUsers"
                                     :placeholder="$t('com.file.add-announcement.search-user-placeholder')"
                                     :close-on-select="false"
                                     :searchable="true"
                                     class="multiselect-green"
                                     :noResultsText="$t('com.global.no-results')"
                                     :noOptionsText="$t('com.global.no-options')"
                                     :options="options2"
                                     @click="setInputFocusUsers">
                                     <template #tag="{ option, handleTagRemove, disabled  }">
                                        <MultiselectPersonTag :option="option" :disabled="disabled" @click="handleTagRemove(option, $event)" />
                                    </template>
                        </Multiselect> 
                    </section>
                </section>
                <label class="esesja-modal__wraper__body__label">{{$t('com.file.announcements.title')}}</label>
                <section class="esesja-modal__row">
                    <textarea maxlength="500"
                              rows="2"
                              :placeholder="$t('com.file.add-announcement.anno-title-placeholder')"
                              class="esesja-modal__wraper__body__input"
                              v-model="title"
                              v-error="{errors, input_key: 'title'}">
                    </textarea>
                    <CharactersCounter :text="title" :maxLenght="sendEmail == true ? 200 : 500" />
                    <ErrorMessage v-if="isError('title', this.errors)" :errorMsgs="passErrorMsg('title',this.errors)" />
                </section>
                <label class="esesja-modal__wraper__body__label">{{$t('com.file.announcements.content')}}</label>
                <section class="esesja-modal__row">
                    <textarea class="esesja-modal__wraper__body__wyswig" v-model="description" v-error="{errors, input_key: 'description'}"></textarea>
                    <ErrorMessage v-if="isError('description', this.errors)" :errorMsgs="passErrorMsg('description',this.errors)" />
                </section>

                <label class="esesja-modal__wraper__body__label">{{$t('com.file.add-announcement.anno-add-time')}}</label>
                <section class="esesja-modal__row-double">
                    <section class="edit-meeting__col-double">
                        <section class="esesja-modal__wraper__body__picker-wrapper">
                            <input type="date"
                                   class="esesja-modal__wraper__body__picker"
                                   v-model="communicat_add_date"
                                   v-error="{ errors, input_key: 'communicat_add_date', }" />
                            <ErrorMessage v-if="isError('communicat_add_date', this.errors)" :errorMsgs="passErrorMsg( 'communicat_add_date', this.errors ) " />
                        </section>
                    </section>
                    <section class="edit-meeting__col-double">
                        <section class="esesja-modal__wraper__body__picker-wrapper">
                            <input type="time"
                                   class="esesja-modal__wraper__body__picker"
                                   v-model="communicat_add_time"
                                   v-error="{ errors, input_key: 'communicat_add_time', }" />
                        </section>
                    </section>
                </section>


                <label class="esesja-modal__wraper__body__label">{{$t('com.file.add-announcement.anno-term')}}</label>
                <section class="esesja-modal__row-double">
                    <section class="esesja-modal__col-double">
                        <section class="esesja-modal__wraper__body__picker-wrapper">
                            <input type="date"
                                   class="esesja-modal__wraper__body__picker"
                                   v-model="meeting_date"
                                   :disabled="!isInCalendar"
                                   v-error="{errors, input_key: 'meeting_date'}" />
                            <ErrorMessage v-if="isError('meeting_date', this.errors)" :errorMsgs="passErrorMsg('meeting_date',this.errors)" />
                        </section>
                    </section>
                    <section class="switch-section">
                        <SwitchButton :label="$t('com.file.add-announcement.show-in-user-calendar')" :isPublic="isInCalendar" @setIsPublic="(value) => (isInCalendar = value)" />
                    </section>
                </section>

                <label class="esesja-modal__wraper__body__label">{{$t('com.file.add-announcement.anno-status')}}</label>
                <section class="checkbox-elements__checkbox-top" style="margin-bottom:10px;">
                    <section class="checkbox-elements__checkbox-wrapper">
                        <input type="checkbox" class="checkbox-elements__checkbox" :checked="notactive" />
                        <section class="checkbox-elements__checkbox-mark">
                            <img src="../../../../../assets/icons/components/accept-mark.svg" />
                        </section>
                    </section>
                    <label class="checkbox-elements__label checkbox-elements__label--checkbox" @click="changeSelectedValue(2);">{{$t('com.file.add-announcement.inactive')}}</label>

                    <section class="checkbox-elements__checkbox-wrapper">
                        <input type="checkbox" class="checkbox-elements__checkbox" :checked="active" />
                        <section class="checkbox-elements__checkbox-mark">
                            <img src="../../../../../assets/icons/components/accept-mark.svg" />
                        </section>
                    </section>
                    <label class="checkbox-elements__label checkbox-elements__label--checkbox" @click="changeSelectedValue(3); ">{{$t('com.file.add-announcement.active')}}</label>

                    <section class="checkbox-elements__checkbox-wrapper">
                        <input type="checkbox" class="checkbox-elements__checkbox" :checked="important" />
                        <section class="checkbox-elements__checkbox-mark">
                            <img src="../../../../../assets/icons/components/accept-mark.svg" />
                        </section>
                    </section>
                    <label class="checkbox-elements__label checkbox-elements__label--checkbox" @click="changeSelectedValue(4); ">{{$t('com.file.add-announcement.important')}}</label>
                </section>

                <label class="esesja-modal__wraper__body__label">{{$t('com.file.add-announcement.send-sms-email-notification')}}</label>
                <section class="checkbox-elements__checkbox-top" style="margin-bottom:20px;">
                    <section class="checkbox-elements__checkbox-wrapper">
                        <input type="checkbox" class="checkbox-elements__checkbox" :checked="sendSms" />
                        <section class="checkbox-elements__checkbox-mark">
                            <img src="../../../../../assets/icons/components/accept-mark.svg" />
                        </section>
                    </section>
                    <label class="checkbox-elements__label checkbox-elements__label--checkbox" @click="sendSms = !sendSms;">sms</label>

                    <section class="checkbox-elements__checkbox-wrapper">
                        <input type="checkbox" class="checkbox-elements__checkbox" :checked="sendEmail" />
                        <section class="checkbox-elements__checkbox-mark">
                            <img src="../../../../../assets/icons/components/accept-mark.svg" />
                        </section>
                    </section>
                    <label class="checkbox-elements__label checkbox-elements__label--checkbox" @click="sendEmail = !sendEmail; ">e-mail</label>
                </section>

                
                <section class="d-flex flex-row justify-content-between pb-3" v-if="sendSms == true || sendEmail == true">
                    <section class="esesja-modal__wraper__body__label information">
                        <p>{{$t('com.file.add-announcement.send-sms-email-alert-info-1')}}</p>
                        <p>{{$t('com.file.add-announcement.send-sms-email-alert-info-2')}}</p>
                        <p>{{$t('com.file.add-announcement.send-sms-email-alert-info-3')}}</p>
                        <p>{{$t('com.file.add-announcement.send-sms-email-alert-info-4')}}</p>
                        <UserAccountEmailSettingsInfo v-if="sendEmail == true" style="margin-top: 10px;" /> 
                    </section>
                </section>

                <section class="esesja-modal__wraper__body__bottom">
                    <button class="esesja-modal__wraper__body__bottom-button" @click="this.$emit('closeAnnoucement')"> {{$t('com.global.cancel')}}</button>
                    <button class="esesja-modal__wraper__body__bottom-button esesja-modal__wraper__body__bottom-button--red" @click="addAnnouncement()" :disabled="(value.length == 0 && value2.length ==0) || title.length == 0 || (sendEmail == true && title.length > 200)">{{$t('com.global.send')}}</button>
                </section>
            </perfect-scrollbar>
        </section>
        <LoaderInside v-if="isLoading" />
    </section>
</template>

<script charset="utf-8">
import moment from "moment";
import LoaderInside from "../../../../BasicControls/LoaderInside.vue";
import UserAccountEmailSettingsInfo from "../../../../Shared/Users/UserAccountEmailSettingsInfo.vue";
import Multiselect from '@vueform/multiselect'
import CommunicationService from "../../../../../services/communication.service";
import SwitchButton from "../../../../BasicControls/SwitchButton.vue";
import ErrorMessage from "../../../../BasicControls/ErrorMessage.vue";
import MultiselectPersonTag from "../../../../BasicControls/Multiselect/MultiselectPersonTag.vue";
import CharactersCounter from "../../../../../components/BasicControls/CharactersCounter.vue"
import {
    passErrorMsg,
    isError,
    setErrors,
    } from "../../../../../formValidation/main";
import AlertHelper from "../../../../../helpers/alerts.helper";

export default {
    name: "AddAnnouncement",
    data() {
        return {
            name: "",
            isLoading: false,
            description: this.elemToUpdate.description,
            value: [...this.selected],
            value2: [...this.selected2],
            isEdit: this.elemToUpdate.isEdit,
            isGroups: true,
            meeting_date: moment(this.elemToUpdate.meetingDate).format("YYYY-MM-DD"),
            communicat_add_time: this.setTimeForCommunicat(),
            communicat_add_date: this.setAddDateForCommunicat(),
            title: this.elemToUpdate.title,
            isInCalendar: this.elemToUpdate.isInCalendar,
            id: this.elemToUpdate.id,
            errors: [],
            sendSms: false,
            sendEmail: false,
            notactive: false,
            active: true,
            importatn: false,
            selected_status: 3,
        };
    },
    props: {
        options: Array,
        options2: Array,
        selected: Array,
        selected2: Array,
        datem: String,
        elemToUpdate: Object
    },
    components: {
        LoaderInside,
        Multiselect,
        ErrorMessage,
        SwitchButton,
        UserAccountEmailSettingsInfo,
        CharactersCounter,
        MultiselectPersonTag
    },
    mounted() {
        this.changeSelectedValue(this.elemToUpdate.status);
    },
    methods: {
        changeGroup(value) {
            this.isGroups = value;
        },
        setInputFocusUsers(){
                const input = this.$refs.searchUsers.$el.querySelector("input");
                if(input)
                    input.focus();
        },
        setInputFocusGroups(){
                const input = this.$refs.searchGroups.$el.querySelector("input");
                if(input)
                    input.focus();
        },
        setAddDateForCommunicat() {
            if (this.elemToUpdate.addTime == null) {
                var dateTime = new Date();
                return moment(dateTime).format("YYYY-MM-DD");
            }
            else {
                return moment(this.elemToUpdate.addTime).format("YYYY-MM-DD");
            }
        },
        setTimeForCommunicat() {
            if (this.elemToUpdate.addTime == null) {
                var time = new Date();
                return moment(time).format("HH:mm");
            }
            else {
                return moment(this.elemToUpdate.addTime).format("HH:mm");
            }
        },
        validate() {
            var bo = true;
            var err = {};
            if (this.title.length <= 0) {
                err.title = [this.$t('com.global.required-field')]
                bo = false
            }

            if (this.title.length > 0) {
                if (!this.title?.trim()) {
                    err.title = [this.$t('com.validation-error.field-only-spaces-error')]
                    bo = false
                }
            }

            if (this.isInCalendar) {
                if (moment(this.meeting_date, 'yyyy-MM-DD', true).isValid() == false) {
                    err.meeting_date = [this.$t('com.validation-error.invalid-date-format')]
                    bo = false
                }
            }

            if (moment(this.communicat_add_date, 'yyyy-MM-DD', true).isValid() == false) {
                err.communicat_add_date = [this.$t('com.validation-error.invalid-date-format')]
                bo = false
            }

            if (!bo) {
                this.isLoading = false;
                this.errors = setErrors(err)
            }
            return bo
        },
        changeSelectedValue(value) {
            if (value != null && value >= 0) {
                this.selected_status = value;
                switch (value) {
                    case 2:
                        // not active
                        this.active = false;
                        this.notactive = true;
                        this.important = false;
                        break;
                    case 3:
                        // active
                        this.active = true;
                        this.notactive = false;
                        this.important = false;
                        break;
                    case 4:
                        // important
                        this.active = false;
                        this.notactive = false;
                        this.important = true;
                        break;
                    default:
                        // default active
                        this.active = true;
                        this.notactive = false;
                        this.important = false;
                        break;
                }
            }
        },
        async addAnnouncement() {
            try {
                if (this.validate() == false)
                    return

                this.isLoading = true;

                var data = {
                    id: 0,
                    title: this.title.trim(),
                    description: this.description,
                    isInCalendar: this.isInCalendar,
                    users: this.value2,
                    groups: this.value,
                    status: this.selected_status,
                    meetingDate: null,
                    addTime: moment(this.communicat_add_date).format("YYYY-MM-DD"),
                    addTimeHours: this.communicat_add_time,
                    sendSms: this.sendSms,
                    sendEmail: this.sendEmail
                }

                if (this.isInCalendar) {
                    data.meetingDate = moment(this.meeting_date).format("YYYY-MM-DD");
                }

                if (this.isEdit) {

                    data.id = this.id;

                    var resultEdit = (await CommunicationService.updateAnnoucementForUsers(data)).data;
                    if (resultEdit > 0) {
                        this.value = [];
                        this.value2 = [];
                        this.title = "";
                        this.description = "";
                        this.isInCalendar = false;
                        this.communicat_add_date = null;
                        this.communicat_add_time = null;

                        data.lastUpdateTime = new Date();
                        data.shows = this.elemToUpdate.shows;
                        data.author = this.elemToUpdate.author;
                        data.files = this.elemToUpdate.files;
                        data.id = resultEdit;
                        data.show = false;
                        this.$emit("closeAnnoucement");
                        this.$emit("updateCalendar", data);
                        this.$swal(AlertHelper.successAlert(this.$t('com.file.add-announcement.anno-created-success-info'), this.$t('com.global.success')));
                        this.isLoading = false;
                    }
                } else {
                    var result = (await CommunicationService.addAnnoucementForUsers(data)).data;
                    if (result > 0) {
                        this.value = [];
                        this.value2 = [];
                        this.title = "";
                        this.description = "";
                        this.isInCalendar = false;
                        this.communicat_add_date = null;
                        this.communicat_add_time = null;

                        data.lastUpdateTime = new Date();
                        data.shows = 0;
                        data.author = this.elemToUpdate.author;
                        data.files = [];
                        data.id = result;
                        data.show = false;
                        this.$emit("closeAnnoucement");
                        this.$emit("updateCalendar", data);
                        this.$swal(AlertHelper.successAlert(this.$t('com.file.add-announcement.anno-created-success-info'), this.$t('com.global.success')));
                        this.isLoading = false;
                    }
                }
            } catch (e) {
                if (e.response !== undefined) {
                    if (e.response.status === 401) {
                        this.$router.push({ name: 'Login' })
                    }
                    else if (e.response.status === 422) {
                        var toast = this.$swal.mixin(AlertHelper.errorToastElement());
                        var no_cred = this.$t('com.file.send-sms.not-enough-credits');
                        var acc = this.$t('com.file.send-sms.accessible');
                        var req = this.$t('com.file.send-sms.required');
                        toast.fire(AlertHelper.errorToastAlert(`${no_cred} ${acc}: ${e.response.data?.availableCredits}, ${req}: ${e.response.data?.requiredCredits}`, this.$t('com.global.error')));
                    }
                    else if (e.response.status === 417) {
                        var toast3 = this.$swal.mixin(AlertHelper.errorToastElement());
                        toast3.fire(AlertHelper.errorToastAlert(e.response.data, this.$t('com.global.error')));
                    }
                    else {
                        var toast2 = this.$swal.mixin(AlertHelper.errorToastElement());
                        toast2.fire(AlertHelper.errorToastAlert(this.$t('com.validation-error.general-error'), this.$t('com.global.error')));
                    }
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        passErrorMsg,
        isError,
        setErrors,
    },
};</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style lang="scss" scoped>
    @use '@/assets/scss/esesja-modal.scss';

    ::v-deep(.multiselect-tags){
        column-gap: 7.5px;
        row-gap: 7.5px;
        max-height: 200px; 
        overflow: hidden; 
        scroll-behavior: smooth; 
        overflow-y: auto; 
    }

    ::v-deep(.multiselect-tags > .multiselect-tags-search-wrapper){
        order: -1;
        flex-basis: 100%;
    }

    .information {
        font-size: 11px;
        padding-bottom: 10px;
        cursor: default;
    }

    .label {
        display: block;
        font-weight: 600;
        font-size: 14px;
        line-height: 145%;
        color: #00082c;
        margin-bottom: 8px;

        &--checkbox {
            padding-left: 36px;
            font-weight: normal;
            font-size: 16px;
            line-height: 144%;
            z-index: 9;
            color: #333956;
            cursor: pointer;
        }
    }

    .multiselect-green {
        --ms-tag-bg: #D1FAE5;
        --ms-tag-color: #059669;
        margin-top: 10px;
    }

    .checkbox {
        font-weight: normal;
        font-size: 16px;
        line-height: 144%;
        color: #333956;
        margin-left: 12px;
        margin-bottom: 0px;
        padding-left: 24px;
        z-index: 0;
        cursor: pointer;
    }

    .checkbox-wrapper {
        display: flex;
        padding: 5px;
        float: left;
    }

    .multiSelectrow {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0px;

        &__elem {
            width: 240px;
        }
    }

    .selectedSection {
        background-color: #dce4ee;
        padding: 5px;
        border-radius: 0px 5px 5px 5px;
    }

    .tabs {
        margin-left: 0px;
        cursor: pointer;
        padding: 5px;
        background-color: #D3D3D3;
        border-radius: 5px 5px 0px 0px;
    }

    .selected {
        background-color: #dce4ee;
        margin: 0px;
        cursor: pointer;
        padding: 5px;
        border-radius: 5px 5px 0px 0px;
    }


    .checkbox-elements {
       
        &__label {
            font-weight: 600;
            font-size: 14px;
            line-height: 145%;
            color: #00082c;

            &--checkbox {
                padding-left: 32px;
                z-index: 10;
                cursor: pointer;
                font-weight: normal !important;
            }

            &--normal {
                font-weight: normal !important;
            }
        }

        &__checkbox-top {
            display: flex;
            align-items: center;
            margin-top: 12px;

            &--col {
                margin-bottom: 13px;
                align-items: flex-start;
            }
        }

        &__checkbox {
            width: 0px;
            height: 0px;
            display: none;

            &:checked ~ .checkbox-elements__checkbox-mark {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &:checked ~ .add-contact-form__label--checkbox {
                padding-left: 0px;
            }
        }

        &__checkbox-wrapper {
            width: 0px;
            height: 24px;
            position: relative;
            margin-left: 20px;

            &:before {
                content: "";
                background: #ffffff;
                border: 1px solid #d1d6df;
                box-sizing: border-box;
                box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
                border-radius: 4px;
                width: 24px;
                height: 24px;
                position: relative;
                display: block;
                top: 0px;
                left: 0px;
                opacity: 1;
            }
        }

        &__checkbox-mark {
            background: #00082c;
            border: 1px solid #00082c;
            box-sizing: border-box;
            box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            width: 24px;
            height: 24px;
            position: absolute;
            z-index: 5;
            display: none;
            top: 0px;
            left: 0px;
            opacity: 1;
        }
    }
</style>
